import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  ADMIN_TERMINALDETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchAdminTerminalDetails = async gid => axiosAuthInstance.get(`${API_END_POINTS.ADMIN_TERMINAL}/${gid}`);

const deleteAdminTerminals = async gid => axiosAuthInstance.delete(`${API_END_POINTS.ADMIN_TERMINAL}/${gid}`);

const patchAdminTerminalPin = async ({ gid, params }) => axiosAuthInstance.post(`${API_END_POINTS.ADMIN_TERMINAL}/${gid}/pin`, params);

export function* getAdminTerminalDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchAdminTerminalDetails, action.payload);
    yield put({ type: ADMIN_TERMINALDETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ADMIN_TERMINALDETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* deleteAdminTerminal(action) {
  try {
    yield put({ type: LOADING.VALIDATING });
    yield put({ type: LOADING.SUBMITTING });
    yield call(deleteAdminTerminals, action.payload);
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.ADMIN_TERMINALDETAILS.DELETE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* updateTerminalPin(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchAdminTerminalPin, action.payload);
    const { data: { entity } } = yield call(fetchAdminTerminalDetails, action.payload.gid);
    yield put({ type: ADMIN_TERMINALDETAILS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.TERMINAL.UPDATE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
